/**
 * @generated SignedSource<<78fe664319c04ed96c88521bdd7793e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TierSelectionItem_tier$data = {
  readonly availableFrom: string | null | undefined;
  readonly availableUntil: string | null | undefined;
  readonly currency: string;
  readonly description: string | null | undefined;
  readonly includeTax: boolean;
  readonly maxPerOrder: number | null | undefined;
  readonly minPerOrder: number;
  readonly name: string;
  readonly price: number;
  readonly status: string;
  readonly taxName: string | null | undefined;
  readonly taxPercentage: number | null | undefined;
  readonly ticketsRemaining: number | null | undefined;
  readonly " $fragmentType": "TierSelectionItem_tier";
};
export type TierSelectionItem_tier$key = {
  readonly " $data"?: TierSelectionItem_tier$data;
  readonly " $fragmentSpreads": FragmentRefs<"TierSelectionItem_tier">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TierSelectionItem_tier",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableUntil",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketsRemaining",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minPerOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxPerOrder",
      "storageKey": null
    }
  ],
  "type": "EventTicketingTier",
  "abstractKey": null
};

(node as any).hash = "415228e175ed0360151c2ad16b7ddfcb";

export default node;
